export const getUrl = (props, backupProps) => {
	const propToUse = props ? props : backupProps.props;
	return propToUse.router && propToUse.router.params ? propToUse.router.params.url : null;
}
